export default __webpack_public_path__ + "static/media/landingPageImage_two.c91d833c.png";